import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Cookies from "js-cookie";
import { keyframes } from "@emotion/react";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export default function TokenCallPopUp({
  open,
  setOpen,
  handleTokenCall,
  handleTokenComplete,
  isLoadingCall,
  tokenValue,
  checkLastCallCount,
}) {
  const handleClickClose = () => {
    setOpen(false);
    Cookies.set("isHoldToken", false);
  };
console.log(checkLastCallCount,"tokenValuewwwww");

  // Check if NextButton cookie is true
  const isNextButtonEnabled = localStorage.getItem("NextButton") === "true";
  
  // Check if there's an existing on-call token
  const hasOnCallToken = checkLastCallCount != null;

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="token-dialog-title"
      aria-describedby="token-dialog-description"
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "12px",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
          animation: `${fadeIn} 0.3s ease-in-out`,
        },
      }}
    >
      <DialogTitle
        id="token-dialog-title"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#2552EB",
          color: "#ffffff",
          padding: "16px 24px",
          borderTopLeftRadius: "12px",
          borderTopRightRadius: "12px",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Token Action
        </Typography>
        <IconButton
          aria-label="close"
          onClick={handleClickClose}
          sx={{ color: "#ffffff" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ padding: "24px" }}>
        {/* Show warning message when NextButton is true and there's an on-call token */}
        {isNextButtonEnabled && hasOnCallToken ? (
          <div className="flex flex-col items-center justify-center py-4">
            <WarningAmberIcon 
              sx={{ 
                fontSize: 48, 
                color: "#ff9800",
                marginBottom: "16px"
              }} 
            />
            <Typography
              variant="h6"
              sx={{
                color: "#ff9800",
                textAlign: "center",
                fontWeight: 600,
                marginBottom: "8px",
              }}
            >
              Action Required
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: "1rem",
                color: "#666666",
                textAlign: "center",
                maxWidth: "80%",
              }}
            >
              Please transfer or hold the existing on-call token before calling a new token.
            </Typography>
          </div>
        ) : (
          // Normal message when no warning needed
          <Typography
            variant="body1"
            sx={{
              fontSize: "1.1rem",
              color: "#000000",
              textAlign: "center",
              marginTop: "10px",
              marginBottom: "8px",
            }}
          >
            What do you want to do with the current token?
          </Typography>
        )}
      </DialogContent>

      <DialogActions sx={{ padding: "16px 24px" }}>
        {isNextButtonEnabled && hasOnCallToken ? (
          // Show only close button when warning is displayed
          <Grid container spacing={2} justifyContent="center">
            <Grid item>
              <Button
                onClick={handleClickClose}
                variant="contained"
                sx={{
                  textTransform: "capitalize",
                  padding: "8px 32px",
                  borderRadius: "8px",
                  fontWeight: 600,
                  backgroundColor: "#2552EB",
                  color: "#ffffff",
                  "&:hover": {
                    backgroundColor: "#1a3bb0",
                  },
                }}
              >
                Close
              </Button>
            </Grid>
          </Grid>
        ) : (
          // Normal button layout when no warning
          <Grid container spacing={2} justifyContent="flex-end">
            {Cookies.get("isHoldToken") === "true" &&
              checkLastCallCount != null && (
                <Grid item>
                  <Button
                    onClick={handleTokenComplete}
                    variant="contained"
                    color="secondary"
                    disabled={isLoadingCall}
                    sx={{
                      textTransform: "capitalize",
                      padding: "8px 24px",
                      borderRadius: "8px",
                      fontWeight: 600,
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                        backgroundColor: "#1e429f",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                      },
                    }}
                  >
                    Complete Token
                  </Button>
                </Grid>
              )}

            {checkLastCallCount != null && (
              <Grid item>
                <Button
                  onClick={() => handleTokenCall(1)}
                  variant="contained"
                  sx={{
                    textTransform: "capitalize",
                    padding: "8px 24px",
                    borderRadius: "8px",
                    fontWeight: 600,
                    backgroundColor: "#2552EB",
                    color: "#ffffff",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    "&:hover": {
                      backgroundColor: "#2552EB",
                      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                    },
                  }}
                  disabled={isLoadingCall}
                >
                  Hold & Call
                </Button>
              </Grid>
            )}

            <Grid item>
              <Button
                onClick={() => handleTokenCall(0)}
                variant="outlined"
                sx={{
                  textTransform: "capitalize",
                  padding: "8px 24px",
                  borderRadius: "8px",
                  fontWeight: 600,
                  borderColor: "#2552EB",
                  color: "#2552EB",
                  borderWidth: "2px",
                  "&:hover": {
                    borderWidth: "2px",
                    backgroundColor: "#e0e7ff",
                  },
                }}
                disabled={isLoadingCall}
              >
                {checkLastCallCount === undefined || checkLastCallCount === null
                  ? "Call"
                  : "Complete & Call"}
              </Button>
            </Grid>
          </Grid>
        )}
      </DialogActions>
    </Dialog>
  );
}